import { useEffect } from 'react'
import './App.css'
import AllRoutes from './routes/routes'
import { ToastContainer } from 'react-toastify'
import './styles/main.css'
import './styles/responsive.css'
import { HTTP_Request } from './utils/interceptor'
import { store } from './shared/redux/store'

function App() {
  // Validate the persisted session against the backend on boot instead of
  // blindly trusting redux-persist. If the token is invalid/expired, /auth/me
  // returns 401 and the axios response interceptor drops the session, so the
  // route guard falls back to login. Network/other errors are ignored (the
  // interceptor only logs out on 401).
  useEffect(() => {
    const token = store.getState()?.root?.user?.user?.token
    if (token) {
      HTTP_Request.get('auth/me').catch(() => {})
    }
  }, [])

  return (
    <div>
      <AllRoutes />
      <ToastContainer />
    </div>
  )
}

export default App
